import {
  Button,
  Text,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Flex,
} from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { CreditAgreementFullArtifactWipConfigType } from 'packages/creditAgreements/ui/types';

type DataSheetOutput = CreditAgreement.Config.Reporting.Outputs.Xlsx.DataSheetOutput;

type EditSheetPropertyModalProps = {
  wipConfig?: CreditAgreementFullArtifactWipConfigType;
  isOpen: boolean;
  onCancel: () => void;
  targetSheet: DataSheetOutput;
  sheetIdxPropertyKey: string;
};
export const EditSheetPropertyModal = ({
  wipConfig,
  isOpen,
  onCancel,
  targetSheet,
  sheetIdxPropertyKey,
}: EditSheetPropertyModalProps) => {
  const [newName, setNewName] = useState<string>(targetSheet.name);

  useEffect(() => {
    setNewName(targetSheet.name);
  }, [targetSheet]);

  const onSave = (): void => {
    if (!wipConfig?.isMutateAllowed(sheetIdxPropertyKey)) {
      onCancel();
      return;
    }

    const updatedSheet: DataSheetOutput = {
      ...targetSheet,
      name: newName,
    };
    wipConfig.formProps.setFieldValue(sheetIdxPropertyKey, updatedSheet);
    onCancel();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onCancel();
      }}
      size="3xl"
    >
      <ModalOverlay />
      <ModalContent p="5" maxWidth="min-content" minWidth="l">
        <ModalHeader>Edit Sheet Property</ModalHeader>
        <ModalCloseButton />
        <ModalBody width="md">
          <Flex alignItems="center" justifyContent="space-between" mb="2">
            <Text>Current Name:</Text>
            <Input
              value={targetSheet.name}
              readOnly
              border="none"
              textAlign="right"
              w="65%"
            />
          </Flex>

          <Flex mb="5" justifyContent="space-between" alignItems="center">
            <Text>New Name:</Text>
            <Input
              type="text"
              onChange={(evt) => {
                setNewName(evt.target.value);
              }}
              value={newName}
              textAlign="right"
              w="65%"
            />
          </Flex>

          <Flex justifyContent="center">
            <Button
              type="button"
              mr="2"
              onClick={() => {
                onSave();
              }}
            >
              Done
            </Button>
            <Button onClick={() => onCancel()}>Cancel</Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
